module.exports = __webpack_public_path__ + "static/img/u394.12aa7210.svg";